<script setup>
import { computed, ref } from 'vue'

const props = defineProps({
	source: {
		type: Array,
		required: true,
		default: () => []
	},
	isLoading: {
		type: Boolean,
		required: false,
		default: () => false
	}
})

const search = ref('')
const searchResults = computed( () => {

	if( search.value === '' ){
		return []
	}

	return props.source.filter( (item) => {
		if( item.title.toLowerCase().includes( search.value.toLowerCase() ) ){
			return item
		}
	})

})

const clearSearch = () => {
	search.value = ''
}

</script>

<template>
	<div class="flex gap-4 desktop:gap-8 text-black relative" @keyup.escape="clearSearch">
		<input 
			v-model="search" 
			type="search" 
			placeholder="Site search by keyword" 
			:class="{  'pointer-events-none' : props.isLoading  }" 
			class="grow border-0 serif-xs placeholder:text-green-light p-2 leading-none focus:outline-none focus:ring-0">
		<!-- <button class="bg-main px-8 py-2 text-main-text serif-xs rounded-lg hover:bg-black transition">Search</button> -->
		<Transition>
			<ul v-show="searchResults.length" class="absolute left-0 top-full divide-y-2 divide-cream w-full drop-shadow-lg">
				<li v-for="result in searchResults" :key="result.id" class="bg-white">
					<a :href="result.permalink" class="flex gap-4 justify-between p-2 hover:bg-main hover:text-main-text focus:bg-main focus:text-main-text focus:outline-none transition" tabindex="0">
						<span class="sans-lg truncate">{{ result.title }}</span>
						<span class="serif-xs shrink-0">{{ result.prices }}</span>
					</a>
				</li>
			</ul>
		</Transition>		
	</div>
</template>

<style>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>